import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMagnifierMinus16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMagnifierMinus16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M7.51 1.01a6.5 6.5 0 0 1 4.935 10.728l2.158 2.158a.5.5 0 0 1-.707.707l-2.158-2.158A6.5 6.5 0 1 1 7.51 1.01m0 1a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m2 5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
            />
        </svg>
    );
}
export default memo(IconMagnifierMinus16);
